import styled from 'styled-components'

export const NFTDetailItemWrapper = styled.div`
  width: 80%;
  display: flex;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    width: 100%;
    display: block;
    padding-bottom: 100px;
  }
`

export const NFTDetailItem = styled.div`
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  max-height: 500px;
  min-height: 500px;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  .crypto-seal-bg {
  }

  .crypto-seal-character {
    position: absolute;
    width: 20%;
  }

  img {
    max-width: 100%;
    max-height: inherit;
  }

  svg {
    max-width: 100%;
    max-height: inherit;
  }

  video {
    max-height: 100%;
  }
`

export const NFTDetailItemMeta = styled.div`
  width: 40%;
  padding: 0.5rem 0 0 1rem;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  .meta-details {
    height: 100%;
    .collection-link {
      color: ${({ theme }) => theme.yetiBlue};
      font-weight: bold;
      font-size: 1.1rem;
      user-select: none;
      cursor: pointer;
      margin-bottom: 0.5rem;
      display: flex;
      align-items: center;

      svg {
        margin-left: 0.5rem;
      }
    }

    .detail-head {
      display: flex;
      justify-content: space-between;
      height: 25px;
      margin-bottom: 0.5rem;

      .title {
        font-weight: bold;
        font-size: 1.3rem;
        margin-bottom: 0.5rem;
        word-break: break-all;
      }
    }

    .price {
      font-weight: bold;
      font-size: 1.2rem;
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
    }

    .owner,
    .creator {
      font-size: 0.8rem;
      cursor: pointer;
      margin-bottom: 0.5rem;

      a {
        text-decoration: none;
        color: ${({ theme }) => theme.yetiBlue};
      }

      span {
        font-weight: bold;
        color: ${({ theme }) => theme.yetiBlue};
      }
    }

    .token-royalties {
      font-size: 0.8rem;
      margin-bottom: 1rem;

      span {
        font-weight: bold;
        font-size: 1rem;
      }
    }

    .description {
      font-size: 0.8rem;
      margin-bottom: 1rem;
      word-break: break-all;
    }

    .properties {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      margin: -0.5rem;

      .property-item {
        width: 33%;

        @media only screen and (max-width: 1024px) {
          width: 50%;
        }
      }
    }
  }

  .buttons {
    display: flex;

    .nft-button {
      margin-right: 0.5rem;

      &:last-child {
        margin-right: 0;
      }
    }
  }
`
